// extracted by mini-css-extract-plugin
export var actionButtonWrapper = "BophUkJpURRL4fvDQjax";
export var addressList = "UQ3UIUzuhfEXr7nmPStV";
export var errorMessage = "zHYK2iAVcTiZrqBt5VsA";
export var helpText = "NcJs46v67qicUpZCt7xF";
export var nameInput = "ityZmLbDsyeIbWTH1yTE";
export var pasteButtonWrapper = "mQzi3S9zvlPqmbhtmp4g";
export var root = "jMgxLdXgkDExKW_1ATKA";
export var warningMessage = "mEE35g7eCiPJHHXO9LOF";